// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/decoy-management/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/decoy-management/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Decoy Management" })
  return <Page />
}
